import script from "./AmazonMusic.vue?vue&type=script&setup=true&lang=js"
export * from "./AmazonMusic.vue?vue&type=script&setup=true&lang=js"

import "./AmazonMusic.vue?vue&type=style&index=0&id=9815ef76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9815ef76"]])

export default __exports__